import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableBody,
  Paper,
  Modal,
  Typography,
  Box,
  Container,
} from "@mui/material";

import LayoutWrapper from "../../../common/LayoutWrapper";
import BookmarkIcon from "../../../assets/icons/BookmarkIcon";
import DeleteIcon from "../../../assets/icons/DeleteIcon";
import SearchIcon from "../../../assets/icons/SearchIcon";
import Checkbox from "../../../common/Checkbox";
import CloseIcon from "@mui/icons-material/Close";

import { SecondaryButton } from "../../../common/Buttons";
import {
  getKeyFromText,
  getUserIdFromLocalStorage,
} from "../../../utils/Utilities";
import "./index.scss";
import {
  downloadPdfGenerateReport,
  getReportList,
  updateReportList,
} from "../../../services/reports";
import { Circles } from "react-loader-spinner";
import Pagination from "../../../common/Pagination";
import { useTranslation } from "react-i18next";

const Report = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  let uID = getUserIdFromLocalStorage();
  let navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [list, setList] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [filterByMarked, setFilterByMarked] = useState(false);
  const [filterByDelete, setFilterByDelete] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const [meta, setMeta] = useState({
    pageSize: 6,
    pageNumber: 1,
    sortOrder: "asc",
    itemsCount: 6,
  });

  const handleChangeCheck = (e) => {
    setList(
      list.map((item) => {
        if (item.reportId == e.target.id)
          return { ...item, isChecked: !item.isChecked };
        return item;
      })
    );
  };
  const handleClickName = () => {
    navigate("/cases/111/family-tree");
  };
  const handleClickBookmark = (ele) => {
    setList(
      list.map((item) => {
        if (item.reportId == ele.reportId)
          return { ...item, isMarked: !item.isMarked };
        return item;
      })
    );
  };
  const fetchData = async () => {
    setLoading(true);
    try {
      const result = await getReportList(uID, localStorage.getItem("caseId"), {
        ...meta,
        filterByMarked,
        filterByDelete,
      });
      if (result?.success) {
        let data = [];
        // if (!filterByDelete && !filterByMarked) {
        //   data = result?.payLoad?.items.map(
        //     (item) => ({ ...item, isChecked: false } || [])
        //   );
        // } else if (filterByDelete && !filterByMarked) {
        //   data =
        //     result?.payLoad?.items
        //       .map((item) => ({ ...item, isChecked: false }))
        //       .filter((ele) => ele.isDeleted) || [];
        // } else if (!filterByDelete && filterByMarked) {
        //   data =
        //     result?.payLoad?.items
        //       .map((item) => ({ ...item, isChecked: false }))
        //       .filter((ele) => ele.isMarked) || [];
        // } else {
        //   data =
        //     result?.payLoad?.items
        //       .map((item) => ({ ...item, isChecked: false }))
        //       .filter((ele) => ele.isMarked || ele.isDeleted) || [];
        // }
        setList(result?.payLoad?.items || []);
        setMeta({
          ...meta,
          pageNumber: result?.payLoad?.currentPage || 1,
          itemsCount: result?.payLoad?.totalCount || data.length,
        });
      }
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };
  const generateReport = async () => {
    setBtnLoading(true);
    try {
      const result = await downloadPdfGenerateReport(id, t);
      if (result?.status === 200) handleRefresh();
    } catch (e) {
      console.log(e);
    } finally {
      setBtnLoading(false);
    }
  };
  const handleClose = () => {
    setDeleteModal(false);
  };
  useEffect(() => {
    fetchData();
  }, [refresh, filterByDelete, filterByMarked]);
  const handleRefresh = () => {
    setRefresh((pre) => !pre);
  };
  const handleUpdateList = async (payload) => {
    const result = await updateReportList(
      payload,
      uID,
      localStorage.getItem("caseId")
    );
    if (result?.success) {
      handleRefresh();
      handleClose();
    }
  };
  const handleDelete = async () => {
    await handleUpdateList(
      list
        .filter((item) => item.isChecked)
        .map((ele) => ({ ...ele, isDeleted: true }))
    );
  };
  const handleChangePage = (item) => {
    setMeta({ ...meta, pageNumber: item });
    handleRefresh();
  };
  return (
    <>
      <div
        className="summary-table"
        style={{
          minHeight: "500px",
          overflow: "auto",
          display: loading ? "flex" : "block",
          justifyContent: "center",
          alignItems: loading && "center",
        }}
      >
        {loading ? (
          <Circles color="#dfc8db" height={80} width={80} />
        ) : (
          <>
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                padding: "1rem",
              }}
            >
              <SecondaryButton
                title={t(getKeyFromText("Generating Report"))}
                border="2px solid #C298BB"
                borderRadius="0.8rem"
                padding="5px 20px"
                bgColor="#C298BB"
                disabled={btnLoading}
                isLoading={btnLoading}
                click={() => {
                  generateReport();
                }}
              />
            </Box>
            <TableContainer component={Paper}>
              <Table
                sx={{ minWidth: 650, maxHeight: "300px", overflow: "auto" }}
                aria-label="simple table"
              >
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ width: "15px" }}>
                      <Box sx={{ display: "flex" }}>
                        <DeleteIcon
                          style={{
                            width: "25px",
                            margin: "10px",
                            opacity: list.every((item) => !item.isChecked)
                              ? "0.6"
                              : "1",
                            cursor: list.every((item) => !item.isChecked)
                              ? "default"
                              : "pointer",
                            pointerEvents: list.every((item) => !item.isChecked)
                              ? "none"
                              : "all",
                          }}
                          onClick={() => {
                            setDeleteModal(true);
                          }}
                        />
                      </Box>
                    </TableCell>
                    <TableCell>
                      <Box sx={{ display: "flex" }}>
                        <Box
                          component="div"
                          sx={{
                            display: "flex",
                            justifyCotent: "center",
                            alignItems: "center",
                            fontWeight: "400",
                            marginRight: "30px",
                            cursor: "pointer",
                            opacity: filterByMarked ? 1 : 0.6,
                          }}
                          onClick={() => {
                            setFilterByMarked((pre) => !pre);
                          }}
                        >
                          <BookmarkIcon
                            style={{
                              width: "20px",
                              display: "flex",
                              alignItems: "center",
                              fill: filterByMarked ? "#FFD76C" : "none",
                              cursor: "pointer",
                            }}
                            color={filterByMarked ? "#FFD76C" : "#A3A3A3"}
                          />
                          {t(getKeyFromText("Marked report"))}
                        </Box>
                        <Box
                          component="div"
                          sx={{
                            display: "flex",
                            justifyCotent: "center",
                            alignItems: "center",
                            fontWeight: "400",
                            cursor: "pointer",
                            opacity: filterByDelete ? 1 : 0.6,
                          }}
                          onClick={() => {
                            setFilterByDelete((pre) => !pre);
                          }}
                        >
                          <DeleteIcon
                            type={"filled"}
                            style={{
                              width: "20px",
                              fill: "black",
                              cursor: "pointer",
                            }}
                          />
                          {t(getKeyFromText("Deleted report"))}
                        </Box>
                      </Box>
                    </TableCell>

                    <TableCell></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {list.map((item) => {
                    return (
                      <TableRow key={item.id}>
                        <TableCell component="th" scope="row">
                          <div
                            style={{
                              marginTop: "-8px",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <Checkbox
                              id={item.reportId}
                              checked={item.isChecked}
                              onChange={handleChangeCheck}
                            />
                          </div>
                        </TableCell>
                        <TableCell>
                          <Box
                            sx={{
                              display: "flex",
                              justifyCotent: "center",
                              alignItems: "center",
                              fontWeight: "400",
                            }}
                          >
                            <BookmarkIcon
                              style={{
                                width: "20px",
                                display: "flex",
                                alignItems: "center",
                                fill: item.isMarked ? "#FFD76C" : "none",
                                cursor: "pointer",
                              }}
                              color={item.isMarked ? "#FFD76C" : "#A3A3A3"}
                              onClick={() => {
                                handleClickBookmark(item);
                                handleUpdateList([
                                  { ...item, isMarked: !item.isMarked },
                                ]);
                              }}
                            />
                            {item.name}
                          </Box>
                        </TableCell>
                        <TableCell></TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
              <Pagination
                itemsCount={meta.itemsCount}
                pageSize={meta.pageSize}
                currentPage={meta.pageNumber}
                onPageChange={handleChangePage}
              />
            </TableContainer>
          </>
        )}
      </div>
      {deleteModal && (
        <Modal
          keepMounted
          open={true}
          onClose={handleClose}
          aria-labelledby="keep-mounted-modal-title"
          aria-describedby="keep-mounted-modal-description"
        >
          <Container maxWidth="xs">
            <Box
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                maxWidth: 400,
                bgcolor: "background.paper",
                borderRadius: "15px",
                boxShadow: 24,
                p: 4,
                textAlign: "center",
                padding: "20px 20px",
                minWidth: 300,
              }}
            >
              <Typography sx={{ textAlign: "right", cursor: "pointer" }}>
                <CloseIcon onClick={handleClose} />
              </Typography>
              <Typography>
                <DeleteIcon
                  style={{
                    width: "35px",
                    margin: "10px",
                  }}
                />
              </Typography>
              <Typography
                id="keep-mounted-modal-title"
                variant="h6"
                component="h2"
              >
                {t("report-delete-text")}
              </Typography>

              <Typography sx={{ mt: 3 }}>
                <SecondaryButton
                  title={t("yes")}
                  textTransform="initial"
                  width={false}
                  padding="0.25rem 3rem"
                  border="2px solid #C498BB40"
                  borderRadius={2}
                  fontSize="0.85rem"
                  fontWeight="500"
                  marginTop="4px"
                  click={handleDelete}
                />
              </Typography>
            </Box>
          </Container>
        </Modal>
      )}
    </>
  );
};

export default Report;
